import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    fieldLabel: {
      fontSize: 13,
      fontWeight: 'bold',
    },
    fieldContent: {
      wordBreak: 'break-word',
      fontSize: '1em',
    },

    infoIcon: {
      float: 'right',
      marginRight: '10px',
      marginLeft: '10px',
    },
    checkbox: {
      verticalAlign: 'middle',
      color: legacyColors.grey5,
      fontSize: 14,
    },
  };
};
